goog.provide('el8.appchart.dialog.disablePatientPassport');

goog.require('el8.service.urls');
goog.require('el8.template.appchart.dialog.disablePatientPassport');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.NewDialog');

el8.appchart.dialog.disablePatientPassport = (function() {

    var successCb = null;
    
    var that = new el8.uiwidget.NewDialog({
        title: 'Disable Patient Passport?',
        modal: true,
        width: 450,
        autoHeight: true,
        contentFn: function() {
            return el8.template.appchart.dialog.disablePatientPassport.content();
        }
    });
    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'disable-patient-passport', 'Disable Patient Passport', function() {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('patientPassport'),
                success: function() {
                    that.hide();
                    if (successCb) { successCb(); }
                }
            });
        }, true
    );
    buttonSet.addButton(
        'cancel-disable', 'Cancel', function() {
            that.hide();
        }, false
    );
    that.setButtonSet(buttonSet);
    
    var super_show = that.show;
    that.show = function(opts) {
        opts = opts || {};
        super_show.call(that);
        successCb = opts.successCb;
    };

    return that;

})();


